import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"
import { useBreakpointIndex } from "@theme-ui/match-media"

const TextImage = styled.div`
    clear: both;
    height: auto;
    display: inline-block;

    .Image_Left_Text_Right,
    .Text_Right_Image_Left {
        float: left;
        margin: 1rem 1.5rem 1rem 0;
        @media screen and (max-width: 800px) {
            clear: both;
        }
    }
    .Image_Right_Text_Left {
        float: right;
        margin: 1rem 0 1rem 1.5rem;
        @media screen and (max-width: 800px) {
            clear: both;
        }
    }
    .Full_Width_Image {
        clear: both;
        text-align: center;
        width: 100%;
    }
`

const ImageSizes = {
    Half: 50,
    One_Third: 33,
    Two_Third: 65,
    One_Quarter: 25,
    Third_Quarter: 75,
}
const Content = styled.div`
    flex: 1;
    margin-bottom: 1rem;
`

const TextWithImage = (props) => {
    const { data, description, doubleText } = props

    const layoutClass = data.Layout_Type
    const imageWidth = ImageSizes[`${data.Image_Size}`]
    const mainImg = getImage(data.image)
    const breakpointIndex = useBreakpointIndex()

    let content = null
    if (doubleText === true) {
        content = (
            <TextImage>
                <div
                    className={layoutClass}
                    style={{
                        width: breakpointIndex > 4 ? `${imageWidth}%` : "100%",
                    }}
                >
                    <GatsbyImage
                        image={mainImg}
                        alt={data.title}
                        className="content-img"
                    />
                </div>
                <div className="content-text">
                    <Content
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    <h2 className="content-title">{data.title}</h2>
                    <Content
                        dangerouslySetInnerHTML={{ __html: data.content }}
                    />
                </div>
            </TextImage>
        )
    } else {
        content = (
            <>
                <TextImage>
                    <h2 className="content-title">{data.title}</h2>
                    <div
                        className={layoutClass}
                        style={{
                            width:
                                breakpointIndex > 4 ? `${imageWidth}%` : "100%",
                        }}
                    >
                        <GatsbyImage
                            image={mainImg}
                            alt={data.title}
                            className="content-img"
                        />
                    </div>
                    <Content
                        dangerouslySetInnerHTML={{ __html: data.content }}
                    />
                </TextImage>
            </>
        )
    }

    return content
}

export default TextWithImage
